import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ThemeModeProvider from './theme/ThemeModeProvider';
import ErrorBoundary from './components/ErrorBoundary';

// Initialize i18n
import './i18n';
import { forgetLegacyStoredToken } from './services/api';

// REV-802: the access token is held in memory now; remove the one an earlier
// version left in localStorage.
forgetLegacyStoredToken();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      {/* REV-491: ThemeModeProvider owns the MUI theme so the user's
          light/dark/system choice actually changes what renders. It supplies
          CssBaseline itself. */}
      <ThemeModeProvider>
        {/* REV-588: the outermost backstop. MainLayout has its own boundary
            around <Outlet /> so a page crash keeps the shell usable, but that
            one is a child of the layout and cannot catch a throw in the shell
            itself — OrgSwitcher in the app bar did exactly that and left an
            empty document. Placed here rather than inside App so it does not
            reindent the whole route table. */}
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </ThemeModeProvider>
    </BrowserRouter>
  </StrictMode>
);
